import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isAndroid } from 'react-device-detect';
import usePortal from 'react-useportal';
import moment from 'moment';

import {
  StyledTeamSquadContainer,
  StyledCard,
  StyledCardDetailItem,
  StyledStayCluster,
  StyledValue,
  StyledLabel,
  StyledPlayerData,
  StyledChartContainer,
  StyledTeamName,
  StyledInjuredLabel,
  StyledLeftLabel,
  StyldRightLabel,
  StyledPlus,
  StyledHeader,
  StyledButtonColumnContainer,
  StyledFullWidthButton,
  StyledInsight,
  StyledToggleTeamView,
  StyledDarkReactTooltip,
  StyledPatronLabel,
} from './styled';

import { ReleasePlayerPopup } from '../Popup';
import { DonutChart, GridChart } from '../Charts';
import { digitFormater } from '../../service/functions';
import {
  rangeColor,
  formRangeColor,
  formRangeStatus,
  simplifiedPosition,
  mindsetStatusToValue,
  transferFeelingColor,
  transferFeeling,
} from '../../service/data';
import { ratingRangeStatus, POPUPS } from '../../service/constants';
import { hidePopupWindow, showPopupWindow } from '../../redux/actions/Popups';
import {
  teamAddToList,
  showMobileSidebarSection,
  teamSetCaptain,
} from '../../redux/actions/Team';
import { sidebarOpenRightPanel } from '../../redux/actions/Sidebar';
import { getPopupsList } from '../../redux/selector/Popups';
import { dataForSidebar } from '../../redux/selector/Sidebar';
import { isPremiumUser } from '../../redux/selector/User';

import { getSeasonNumber, getOwnPlayerRow, getCurrentMatchRunning, getCaptain } from '../../redux/selector/Team';
import { canBeCaptain, isCaptain, captainChangeCopy } from '../../service/captain';
import {
  isSuspended,
  isSentOff,
  SENT_OFF_COPY,
  yellowCardCount,
  suspendedLabelCopy,
  yellowCardsLabel,
  YELLOW_CARD_RULE_COPY,
} from '../../service/availability';

import { ReactComponent as Crown } from '../../assets/img/crown.svg';
import ShortlistToggle from '../ShortlistToggle';
import CareerHistoryLink from '../CareerHistoryLink';
import ClubStayStats from '../ClubStayStats';
import { formatEstimatedValue } from '../../service/playerValue';
import {
  seasonCleanSheetsAll,
  showsCleanSheets,
} from '../../service/playerStats';

export default function PlayerStatCard({
  playerWhoWasSold,
  isMobile,
  academyList = [],
}) {
  const {
    _id,
    first_name,
    last_name,
    rating_range,
    media_rating,
    recovery_time,
    fav_position,
    previous_rating,
    age,
    potential_range,
    goals_scored,
    assists,
    played_matches,
    form_range,
    salary,
    team,
    life_stage,
    worst_mindset,
    fav_opponent,
    worst_opponent,
    fav_style,
    fav_mindset,
    second_fav_position,
    transfer_feeling,
    contract
  } = playerWhoWasSold;
  const seasons = contract?.data?.length;
  const seasonsCount = contract?.current_stats.seasons_count;
  const seasonsLeft = seasons - seasonsCount;
  const { RELEASE_PLAYER_POPUP, PLAYER_INFO_POPUP_VIEW } = POPUPS;
  const rating = ratingRangeStatus[rating_range];
  const [isShowingOverview, changeCardOverview] = React.useState(true);

  const freeAgentPopupData = useSelector(getPopupsList);
  const isPremium = useSelector(isPremiumUser);
  const seasonNumber = useSelector(getSeasonNumber);
  const ownRow = useSelector(getOwnPlayerRow(_id));
  const matchRunning = useSelector(getCurrentMatchRunning);
  const sentOff = isSentOff(matchRunning, _id);
  const captain = useSelector(getCaptain);
  // Own players only (a squad or strategy row), with the captain block present (Match Engine 2.5).
  const canPickAsCaptain = Boolean(captain) && Boolean(ownRow) &&
    canBeCaptain(ownRow, academyList) && !isCaptain(captain, _id);
  const { cash } = useSelector(dataForSidebar);

  const dispatch = useDispatch();
  const { Portal } = usePortal({
    bindTo: document && document.querySelector('#modal'),
  });

  const getTheAppLinks = () => {
    dispatch(showPopupWindow(POPUPS.MOBILE_REQUIRED_POPUP, POPUPS.MOBILE_REQUIRED_POPUP))
  };

  const setPlayerInfo = (player) => {
    dispatch(hidePopupWindow(PLAYER_INFO_POPUP_VIEW));
    dispatch(sidebarOpenRightPanel(true));
    dispatch(teamAddToList(player));
  };
  const showPlayersList = () => {
    dispatch(hidePopupWindow(PLAYER_INFO_POPUP_VIEW));
    dispatch(showMobileSidebarSection('list'));
  };
  const getRecoveryDate = (date) => {
    const eventdate = moment.utc(date).add(1, 'days');
    const todaysdate = moment();
    const daysLeft = eventdate.diff(todaysdate, 'days');
    return `${daysLeft < 1 ? 1 : daysLeft} day${daysLeft > 1 ? 's' : ''}`;
  };
  const teamName = () => {
    if (academyList.includes(_id)) {
      return;
    }
    if (team && life_stage !== 3) {
      return team.name;
    }
    if (team && life_stage === 3) {
      return 'Retired';
    }

    return 'Free agent';
  };
  if (playerWhoWasSold) {
    const reverseRating = [...media_rating];
    reverseRating.reverse();
    const reversePrevRating = [...previous_rating];
    reversePrevRating.reverse();
    const formRange = formRangeStatus[form_range];
    const potentialRange = ratingRangeStatus[potential_range];
    return (
      <>
        {freeAgentPopupData[RELEASE_PLAYER_POPUP] && (
          <Portal>
            <ReleasePlayerPopup
              cash={cash}
              popupName={RELEASE_PLAYER_POPUP}
              id={_id}
              salary={salary}
              seasonsLeft={seasonsLeft}
            />
          </Portal>
        )}
        <StyledTeamSquadContainer>
          <StyledHeader>
            <h3>
              {first_name} {last_name}{' '}
              <ShortlistToggle playerId={_id} />
            </h3>
            <StyledTeamName>{teamName()}</StyledTeamName>
            <StyledToggleTeamView className="formations-section">
              <button
                className={isShowingOverview ? 'active' : ''}
                onClick={() => changeCardOverview(true)}
                type="button"
              >
                Player Overview
              </button>
              <button
                className={!isShowingOverview ? 'active' : ''}
                onClick={
                  isPremium
                    ? () => changeCardOverview(false)
                    : () => getTheAppLinks()
                }
                type="button"
              >
                <StyledInsight
                  {...(!isPremium && {
                    'data-tip': true,
                    'data-event': 'click',
                    clickable: true,
                    'data-for': 'insights',
                  })}
                >
                  Insights
                  <Crown />
                </StyledInsight>
              </button>
            </StyledToggleTeamView>
          </StyledHeader>
          <StyledCard>
            <>
              {recovery_time && (
                <StyledInjuredLabel type="injured">
                  <StyledLeftLabel>
                    <StyledPlus>+</StyledPlus>Player is injured
                  </StyledLeftLabel>
                  <StyldRightLabel>
                    Returns in: {getRecoveryDate(recovery_time)}
                  </StyldRightLabel>
                </StyledInjuredLabel>
              )}
              {isSuspended(ownRow) && (
                <StyledInjuredLabel type="suspended">
                  <StyledLeftLabel>Suspended</StyledLeftLabel>
                  <StyldRightLabel>{suspendedLabelCopy(ownRow)}</StyldRightLabel>
                </StyledInjuredLabel>
              )}
              {yellowCardCount(ownRow) > 0 && (
                <StyledInjuredLabel type="booked">
                  <StyledLeftLabel>{yellowCardsLabel(yellowCardCount(ownRow))}</StyledLeftLabel>
                  <StyldRightLabel>{YELLOW_CARD_RULE_COPY}</StyldRightLabel>
                </StyledInjuredLabel>
              )}
              {academyList.includes(_id) && (
                <StyledInjuredLabel type="academy">
                  <StyledLeftLabel>Academy</StyledLeftLabel>
                  <StyldRightLabel>
                    Returns at the end of season
                  </StyldRightLabel>
                </StyledInjuredLabel>
              )}
              {isShowingOverview ? (
                <>
                  <StyledPlayerData>
                    <StyledCardDetailItem half topBorder>
                      <>
                        <StyledValue>
                          {simplifiedPosition[fav_position] || 'N/A'}
                        </StyledValue>
                        <StyledLabel>Position</StyledLabel>
                      </>
                    </StyledCardDetailItem>
                    <StyledCardDetailItem half topBorder>
                      <>
                        <StyledValue>{age || 'N/A'}</StyledValue>
                        <StyledLabel>Age</StyledLabel>
                      </>
                    </StyledCardDetailItem>
                  </StyledPlayerData>
                  <StyledPlayerData>
                    <StyledCardDetailItem>
                      <>
                        <StyledValue color={rangeColor[rating]}>
                          {rating || 'N/A'}
                        </StyledValue>
                        <StyledLabel>Rating</StyledLabel>
                      </>
                    </StyledCardDetailItem>
                    <StyledCardDetailItem>
                      <>
                        <StyledValue color={rangeColor[potentialRange]}>
                          {potentialRange || 'N/A'}
                        </StyledValue>
                        <StyledLabel>Potential</StyledLabel>
                      </>
                    </StyledCardDetailItem>
                    <StyledCardDetailItem>
                      <>
                        <StyledValue color={formRangeColor[formRange]}>
                          {formRange || 'N/A'}
                        </StyledValue>
                        <StyledLabel>Fitness</StyledLabel>
                      </>
                    </StyledCardDetailItem>
                  </StyledPlayerData>
                  {!isMobile ? (
                    <>
                      <StyledChartContainer>
                        {reverseRating.map((item, index) => (
                          <DonutChart
                            key={`${item}${index}`}
                            index={index + 1}
                            arcSize={item}
                          />
                        ))}
                      </StyledChartContainer>
                      <StyledChartContainer>
                        <GridChart
                          currentRating={rating}
                          seasonNumber={seasonNumber}
                          data={reversePrevRating}
                        />
                      </StyledChartContainer>
                      <StyledPlayerData>
                        <StyledCardDetailItem>
                          <>
                            <StyledValue>
                              {Number.isInteger(goals_scored)
                                ? goals_scored
                                : '-'}
                            </StyledValue>
                            <StyledLabel>League goals</StyledLabel>
                          </>
                        </StyledCardDetailItem>
                        <StyledCardDetailItem>
                          <>
                            <StyledValue>
                              {Number.isInteger(assists) ? assists : '-'}
                            </StyledValue>
                            <StyledLabel>League assists</StyledLabel>
                          </>
                        </StyledCardDetailItem>
                        <StyledCardDetailItem>
                          <>
                            <StyledValue>
                              {Number.isInteger(played_matches)
                                ? played_matches
                                : '-'}
                            </StyledValue>
                            <StyledLabel>Starts</StyledLabel>
                          </>
                        </StyledCardDetailItem>
                        {showsCleanSheets(playerWhoWasSold) ? (
                          <StyledCardDetailItem>
                            <>
                              <StyledValue>
                                {seasonCleanSheetsAll(playerWhoWasSold)}
                              </StyledValue>
                              <StyledLabel>Clean sheets</StyledLabel>
                            </>
                          </StyledCardDetailItem>
                        ) : null}
                      </StyledPlayerData>
                      <ClubStayStats
                        stay={playerWhoWasSold.clubStay}
                        Row={StyledPlayerData}
                        Item={StyledCardDetailItem}
                        Value={StyledValue}
                        Label={StyledLabel}
                        Cluster={StyledStayCluster}
                        trailing={<CareerHistoryLink playerId={_id} />}
                      />
                      <StyledPlayerData>
                        {!playerWhoWasSold.clubStay ? (
                          <StyledCardDetailItem>
                            <CareerHistoryLink playerId={_id} />
                          </StyledCardDetailItem>
                        ) : null}
                        <StyledCardDetailItem half={Boolean(playerWhoWasSold.clubStay)}>
                          <>
                            <StyledValue>{formatEstimatedValue(playerWhoWasSold)}</StyledValue>
                            <StyledLabel>Est. Value</StyledLabel>
                          </>
                        </StyledCardDetailItem>
                        <StyledCardDetailItem half={Boolean(playerWhoWasSold.clubStay)}>
                          <>
                            <StyledValue>
                              ${digitFormater(salary / 7, 0) || '-'}
                            </StyledValue>
                            <StyledLabel>Daily Salary</StyledLabel>
                          </>
                        </StyledCardDetailItem>
                      </StyledPlayerData>
                    </>
                  ) : (
                    <StyledButtonColumnContainer>
                      <StyledFullWidthButton
                        primary
                        disabled={sentOff}
                        title={sentOff ? SENT_OFF_COPY : undefined}
                        onClick={() => {
                          showPlayersList();
                        }}
                      >
                        Replace Player
                      </StyledFullWidthButton>
                      {canPickAsCaptain && (
                        <StyledFullWidthButton
                          secondary
                          disabled={!captain.change?.allowed}
                          title={captainChangeCopy(captain.change) || undefined}
                          onClick={() => dispatch(teamSetCaptain(_id))}
                        >
                          Make captain
                        </StyledFullWidthButton>
                      )}
                      <StyledFullWidthButton
                        secondary
                        onClick={() => {
                          setPlayerInfo(playerWhoWasSold);
                        }}
                      >
                        See player profile
                      </StyledFullWidthButton>
                    </StyledButtonColumnContainer>
                  )}
                </>
              ) : (
                <>
                  <StyledPlayerData>
                    <StyledCardDetailItem topBorder half>
                      <>
                        <StyledValue>
                          {isPremium && (fav_style || '—')}
                        </StyledValue>
                        <StyledLabel>Favourite Style</StyledLabel>
                      </>
                    </StyledCardDetailItem>
                    <StyledCardDetailItem topBorder half>
                      <>
                        <StyledValue>
                          {isPremium && simplifiedPosition[second_fav_position]}
                        </StyledValue>
                        <StyledLabel>Alternate Position</StyledLabel>
                      </>
                    </StyledCardDetailItem>
                  </StyledPlayerData>
                  <StyledPlayerData>
                    <StyledCardDetailItem half>
                      <>
                        <StyledValue color="#00996b">
                          {isPremium && mindsetStatusToValue[fav_mindset]}
                        </StyledValue>
                        <StyledLabel>Favourite Mindset</StyledLabel>
                      </>
                    </StyledCardDetailItem>
                    <StyledCardDetailItem half>
                      <>
                        <StyledValue color="#d63c30">
                          {isPremium && mindsetStatusToValue[worst_mindset]}
                        </StyledValue>
                        <StyledLabel>Worst Mindset</StyledLabel>
                      </>
                    </StyledCardDetailItem>
                  </StyledPlayerData>
                  <StyledPlayerData>
                    <StyledCardDetailItem>
                      <>
                        <StyledValue color="#00996b">
                          {isPremium && fav_opponent}
                        </StyledValue>
                        <StyledLabel>Favourite Opponent</StyledLabel>
                      </>
                    </StyledCardDetailItem>
                  </StyledPlayerData>
                  <StyledPlayerData>
                    <StyledCardDetailItem>
                      <>
                        <StyledValue color="#d63c30">
                          {isPremium && worst_opponent}
                        </StyledValue>
                        <StyledLabel>Worst Opponent</StyledLabel>
                      </>
                    </StyledCardDetailItem>
                  </StyledPlayerData>
                  {Number(transfer_feeling) ? (
                    <StyledPlayerData>
                      <StyledCardDetailItem>
                        <>
                          <StyledValue
                            color={transferFeelingColor[transfer_feeling]}
                          >
                            {isPremium && transferFeeling[transfer_feeling]}
                          </StyledValue>
                          <StyledLabel>Club Fit</StyledLabel>
                        </>
                      </StyledCardDetailItem>
                    </StyledPlayerData>
                  ) : null}
                </>
              )}
            </>
          </StyledCard>
        </StyledTeamSquadContainer>
      </>
    );
  }
  return null;
}
